"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var errorHandler_1 = require("../service/errorHandler");
var url_join_1 = require("url-join");
var FinanceBreakDownViews_1 = require("../../../../../common/enum/FinanceBreakDownViews");
var assetManager_1 = require("../../../common/service/assetManager");
var constants_1 = require("../../../../../common/constants/constants");
var useDestroyIfExists_1 = require("../hooks/useDestroyIfExists");
var FinanceSummaryWidget = function (_a) {
    var financeWidgetUrl = _a.financeWidgetUrl, financeWidgetPath = _a.financeWidgetPath, financeWidgetChunkPath = _a.financeWidgetChunkPath, setLoadingStatus = _a.setLoadingStatus, dimensions = _a.dimensions, breakdown = _a.breakdown, handleErrors = _a.handleErrors;
    var _b = react_1.useState(null), widgetInstance = _b[0], setWidgetInstance = _b[1];
    var _c = react_1.useState(1), widgetCount = _c[0], setWidgetCount = _c[1];
    var widgetId = react_1.useState('finance_widget_' + widgetCount)[0];
    useDestroyIfExists_1.default(widgetInstance, breakdown);
    react_1.useEffect(function () {
        setWidgetCount(widgetCount + 1);
        ensureLibraryLoaded().then(function () { return initializeWidget(); });
    }, []);
    react_1.useEffect(function () {
        if (widgetInstance) {
            ensureLibraryLoaded().then(function () { return initializeWidget(); });
        }
    }, [breakdown]);
    var initializeWidget = function () {
        if (!FC) {
            throw new Error("Attempted to use Finance library without loading first");
        }
        var config = {
            containerId: widgetId,
            breakdown: breakdown,
            dimensions: dimensions,
            version: constants_1.constants.NEW,
            viewMode: FinanceBreakDownViews_1.FinanceBreakDownViews.BREAKDOWN,
        };
        setLoadingStatus(true);
        return FC.InchcapeFinance.createWidget(config)
            .then(function (widget) {
            var _a;
            setWidgetInstance(widget);
            widget.on((_a = FC.Summary) === null || _a === void 0 ? void 0 : _a.Events.ERROR, function (data) {
                if (typeof handleErrors === 'function') {
                    handleErrors(data);
                }
            });
        })
            .catch(errorHandler_1.default.handleError)
            .finally(function () { return setLoadingStatus(false); });
    };
    var ensureLibraryLoaded = function () {
        var widgetUrl = url_join_1.default(financeWidgetUrl + financeWidgetPath);
        var widgetChunkUrl = url_join_1.default(financeWidgetUrl + financeWidgetChunkPath);
        return assetManager_1.assetManager.loadScript(widgetChunkUrl).then(function () { return assetManager_1.assetManager.loadScript(widgetUrl); });
    };
    return <div id={widgetId}/>;
};
exports.default = FinanceSummaryWidget;
